import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { map, Observable } from 'rxjs';
import { QQQuestionnairePageViewModel } from 'src/app/models/qq-questionnaire-page.view-model';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';

@Component({
  selector: 'app-apg-quick-quote-header',
  templateUrl: './apg-quick-quote-header.component.html',
  styleUrls: ['./apg-quick-quote-header.component.scss'],
})
export class ApgQuickQuoteHeaderComponent implements OnInit, OnChanges {
  @Input() quickQuote: QQQuestionnaireViewModel;

  progress$: Observable<{ step: string, complete: boolean }[]>;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['quickQuote']?.currentValue)
      this.progress$ = this.quickQuote.visiblePages$.pipe(
        map(pages => this.mapSteps(pages, this.quickQuote.currentPage))
      );
  }

  mapSteps(pages: QQQuestionnairePageViewModel[], currentPage: QQQuestionnairePageViewModel) {
    let lastStep: { step: string, complete: boolean } = null;
    let complete = true;

    return pages.reduce((acc, page) => {
      if (!lastStep || (page.step && page.step !== lastStep.step)) {
        lastStep = { step: page.step, complete };
        acc.push(lastStep);
      }

      if (complete && page === currentPage)
        complete = false;

      return acc;
    }, []);
  }

}
